export default class Form {
  constructor() {
    window.addEventListener("load", () => {
      this.cryptoPasswordFields = document.querySelectorAll("input.crypto");
      if (this.cryptoPasswordFields) this.init();
    });
  }

  init() {
    var formIdentified = false;
    var self = this;
    this.cryptoPasswordFields.forEach((field) => {
      if (!formIdentified) {
        formIdentified = true;
        field.form.onsubmit = self.checkFlag.bind(self);
      }
    });
  }

  checkFlag(event) {
    event.preventDefault();
    event.stopPropagation();
    var self = this;

    var results = [];

    this.cryptoPasswordFields.forEach((field) => {
      window
        .fetch("/api/crypto/result", {
          method: "POST",
          mode: "same-origin",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
          },
          redirect: "follow",
          referrerPolicy: "no-referrer",
          body: JSON.stringify({
            Flag: field.value,
            EncVal: window["enc" + field.id.replace(/-/g, "")],
          }),
        })
        .then((response) => response.json())
        .then((data) => {
          results.push(data);

          if (!data) {
            self.undisableSubmit();
            self.invalidateField(field);
          } else {
            if (
              results.indexOf(false) == -1 &&
              results.length == self.cryptoPasswordFields.length
            ) {
              field.form.submit();
            }
          }
        })
        .catch((error) => {
          results.push(false);
          console.log("Error:", error);
          self.undisableSubmit();
        });
    });
  }

  undisableSubmit() {
    var submitButtons = document.querySelectorAll(
      ".umbraco-forms-ncc input[type=submit], .umbraco-forms-ncc button[type=submit]"
    );

    submitButtons.forEach((field) => {
      field.disabled = false;
    });
  }

  invalidateField(field) {
    field.nextElementSibling.nextElementSibling.classList.remove(
      "field-validation-valid"
    );
    if (
      !field.nextElementSibling.nextElementSibling.classList.contains(
        "field-validation-error"
      )
    ) {
      field.nextElementSibling.nextElementSibling.classList.add(
        "field-validation-error"
      );
    }

    if (!field.classList.contains("input-validation-error")) {
      field.classList.add("input-validation-error");
    }

    var incorrectText = field.dataset.valIncorrect;

    while (field.nextElementSibling.nextElementSibling.firstChild) {
      field.nextElementSibling.nextElementSibling.removeChild(
        field.nextElementSibling.nextElementSibling.lastChild
      );
    }

    var errorNode = document.createElement("span"); // Create a <li> node
    var textnode = document.createTextNode(incorrectText);

    errorNode.appendChild(textnode);
    errorNode.id = field.id + "-error";

    field.nextElementSibling.nextElementSibling.appendChild(errorNode);
  }
}
